"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IpmDownloader = void 0;
const fflate_1 = require("fflate");
const js_sha256_1 = require("js-sha256");
const InsightsClient_1 = require("./InsightsClient");
const IpmDataError_1 = require("./IpmDataError");
const utils_1 = require("./utils");
const Logger_1 = __importDefault(require("../Logger"));
const Common_1 = require("../utils/Common");
class IpmDownloader {
    constructor(context) {
        this.context = context;
        this.unzipAsync = (0, Common_1.promisify)(fflate_1.unzip);
        this.textDecoder = new TextDecoder();
    }
    buildRuleEngines(filter) {
        return __awaiter(this, void 0, void 0, function* () {
            const allRules = yield this.fetchInsightRules(filter);
            Logger_1.default.debug("fetchRuleEngines: allInsights", allRules);
            // Skip importing `groupBy` from lodash. Reduces unminified bundle by approx. 1MB; minified bundle by approx. 100kB
            const rulesByEngine = allRules.reduce((state, rule) => {
                var _a;
                // eslint-disable-next-line no-param-reassign
                (state[rule.rulesEngine.name] = (_a = state[rule.rulesEngine.name]) !== null && _a !== void 0 ? _a : []).push(rule);
                return state;
            }, {});
            const enginePromises = Object.entries(rulesByEngine).map(([name, rules]) => __awaiter(this, void 0, void 0, function* () {
                const engineArtifact = yield this.fetchEngineArtifactByName(name);
                Logger_1.default.debug("fetchRuleEngines: engineArtifact", engineArtifact);
                return [
                    name,
                    {
                        name,
                        version: engineArtifact.engine.version,
                        artifact: engineArtifact.artifact,
                        rules,
                    },
                ];
            }));
            return Object.fromEntries(yield Promise.all(enginePromises));
        });
    }
    fetchInsightRules(filter) {
        return __awaiter(this, void 0, void 0, function* () {
            Logger_1.default.debug("BEGIN getInsightRules", filter);
            const token = (0, utils_1.oxygenTokenFrom)(this.context.analytics);
            if (!token) {
                throw new Error("No user token available");
            }
            const queryResult = yield (0, InsightsClient_1.query)({ name: "getInsightRules", filter }, { http: this.context.http, env: (0, utils_1.envFrom)(this.context.analytics), token });
            Logger_1.default.debug("END getInsightRules", queryResult);
            if (queryResult.errors) {
                const errorMessage = queryResult.errors.map((error) => error.message).join("\n");
                throw new IpmDataError_1.IpmDataError(errorMessage);
            }
            const rules = queryResult.data.getInsightRules;
            const insightsPromises = rules.map((rule) => __awaiter(this, void 0, void 0, function* () { return this.downloadZip(rule); }));
            const allInsights = yield Promise.all(insightsPromises);
            return allInsights
                .flatMap((scripts) => scripts)
                .map((script) => (0, Common_1.evalAndGet)(script, "insights"))
                .flatMap((insights) => insights)
                .filter((insights) => !!insights.rulesEngine);
        });
    }
    fetchEngineArtifactByName(name) {
        return __awaiter(this, void 0, void 0, function* () {
            const result = yield this.fetchEngineArtifact({ engine: name, latest: true });
            if (result.length !== 1) {
                throw new IpmDataError_1.IpmDataError(`Fetching engine ${name} result length should be 1 instead of ${result.length}`);
            }
            return result[0];
        });
    }
    fetchEngineArtifact(filter) {
        return __awaiter(this, void 0, void 0, function* () {
            Logger_1.default.debug("BEGIN getInsightRulesEngines", filter);
            const token = (0, utils_1.oxygenTokenFrom)(this.context.analytics);
            if (!token) {
                throw new Error("No user token available");
            }
            const queryResult = yield (0, InsightsClient_1.query)({ filter, name: "getInsightRulesEngines" }, { http: this.context.http, env: (0, utils_1.envFrom)(this.context.analytics), token });
            Logger_1.default.debug("END insightRulesEngines", queryResult);
            if (queryResult.errors) {
                const errorMessage = queryResult.errors.map((error) => error.message).join("\n");
                throw new IpmDataError_1.IpmDataError(errorMessage);
            }
            const insightRulesEngines = queryResult.data.getInsightRulesEngines;
            const downloadPromises = insightRulesEngines.map((engine) => __awaiter(this, void 0, void 0, function* () {
                const scripts = yield this.downloadZip(engine);
                return { engine, artifact: scripts.join("\n") };
            }));
            return Promise.all(downloadPromises);
        });
    }
    downloadZip({ url, checksum }) {
        return __awaiter(this, void 0, void 0, function* () {
            const buffer = yield this.context.http.getBuffer(url);
            const binary = new Uint8Array(buffer);
            const hash = (0, js_sha256_1.sha256)(binary);
            if (hash !== checksum) {
                throw new IpmDataError_1.IpmDataError(`Checksum error, actual: ${hash}, expected: ${checksum} for ${url}.`);
            }
            const unzipped = yield this.unzipAsync(binary);
            Logger_1.default.debug("downloadZip: unzip", unzipped);
            const decoded = Object.values(unzipped).map((file) => this.textDecoder.decode(file));
            Logger_1.default.debug("downloadZip: decoded", decoded);
            return decoded;
        });
    }
}
exports.IpmDownloader = IpmDownloader;
